import { lazy } from 'react';

const CustomElement = lazy(() => import('./CustomElement'));

export default CustomElement;
